module.exports = __webpack_public_path__ + "static/media/aviation-glider-hydroelectric-svgrepo-com.8b85184e.svg";